import { Button, Icon, enums, utils as u } from 'edrolo-ui';
import { AttachmentType } from '../../../../../../enums/Attachments';
import { Attachment } from '../../../../../../types/Assemblage';
import s from './styles.scss';
import { ATTACHMENT_MIME_TYPES_TO_LABELS } from '../../constants';
import { useAnalytics } from 'edrolo/analytics';

interface Props {
  attachments: Attachment[];
}
export const CardAttachments = ({ attachments }: Props): JSX.Element => {
  const { track } = useAnalytics({});
  return (
    <div className={s.cardAttachments}>
      {attachments.map((a) => {
        const label =
          ATTACHMENT_MIME_TYPES_TO_LABELS[
            a.mime_type as keyof typeof ATTACHMENT_MIME_TYPES_TO_LABELS
          ];

        return (
          <Button.Anchor
            key={a.id}
            className={u.mr2}
            target="_blank"
            href={a.url}
            variant={enums.Variant.FADE}
            color={enums.ColorTheme.PRIMARY}
            onClick={() => {
              track('attachment clicked', {
                origin: 'attachment card',
                // TODO these should be added to an enrichment endpoint
                attachment_id: a.id,
                attachment_title: a.title,
                attachment_url: a.url,
                attachment_category: a.category,
                attachment_type: a.attachment_type,
                attachment_mime_type: a.mime_type,
              });
            }}
          >
            <Icon
              name={
                a.attachment_type === AttachmentType.LINK
                  ? enums.Icons.EXTERNAL_LINK
                  : enums.Icons.DOWNLOAD
              }
              className={u.mr2}
            />
            {a.attachment_type === AttachmentType.LINK ? 'View ' : 'Download '}
            {label || 'attachment'}
          </Button.Anchor>
        );
      })}
    </div>
  );
};
